import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from './../../services/user.service';
import { AuthService } from './../../services/auth.service';
import { ChatService } from './../../services/chat.service';
import { SubscribeNowModalComponent } from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';

@Component({
  selector: 'shc-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss'],
})
export class TabsPage implements OnInit {
  user: UserModel;
  unreadChatsCount = 0;

  constructor(
    public router: Router,
    private userService: UserService,
    private modalCtrl: ModalController,
    private authService: AuthService,
    private chatService: ChatService,
  ) { }

  ngOnInit() {
    this.chatService.unreadChatsCount$.subscribe(count => {
      this.unreadChatsCount = count;
    });
  }

  ionViewWillEnter() {
    this.authService.loggedIn.subscribe((loggedIn) => {
      if (loggedIn) {
        this.userService.getUpdatedUser().subscribe(res => {
          this.user = res;
        });
        this.chatService.refreshUnreadChatsCount();
      }
    });
  }

  routeToAddProduct() {
    if (this.user.products_count >= this.user.allowed_products && (this.user.is_premium !== 1 || this.user.is_subscribed !== 1)) {
      this.subscribeNow();
    } else {
      this.router.navigate(['create-product']);
    }
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
      canDismiss: true
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

}
